export default __webpack_public_path__ + "static/SharpGroteskBook20-Regular-b504ac1f3f9976cf001a1beba99c063f.woff";